<template>
  <a-card class="height-100-per" :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="基地">
              <j-dict-select-tag placeholder="请选择基地" v-model="queryParam.baseId" dictCode="bus_inspection_base,base,id"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="配置类型">
              <j-dict-select-tag placeholder="请选择配置类型" v-model="queryParam.configType" dictCode="standard_team_task_type"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary"  icon="plus">新增</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('巡检部门配置表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :rowClassName="rowClassName"
        :customRow="customRow"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="图片不存在" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <!-- <a-divider type="vertical" /> -->
          <!-- <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>

      </a-table>
    </div>

    <departModal-new ref="modalForm" @ok="modalFormOk"></departModal-new>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DepartModalNew from '../modules/DepartModalNew'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import JInput from '@/components/jeecg/JInput.vue'

  export default {
    name: "BusStandardTeamConfigModal",
    mixins:[JeecgListMixin],
    components: {
      DepartModalNew,
      JInput
    },
    data () {
      return {
        description: '标准化班组配置表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'基地',
            align:"center",
            dataIndex: 'baseId_dictText'
          },
          {
            title:'配置名称',
            align:"center",
            dataIndex: 'configName'
          },
          {
            title:'配置类型',
            align:"center",
            dataIndex: 'configType_dictText'
          },
          {
            title:'配置备注',
            align:"center",
            dataIndex: 'configRemark'
          },
          {
            title:'任务生成类型',
            align:"center",
            dataIndex: 'createTaskType'
          },
          {
            title:'开始时间',
            align:"center",
            dataIndex: 'startTime'
          },
          {
            title:'结束时间',
            align:"center",
            dataIndex: 'endTime'
          },
          {
            title:'计划次数',
            align:"center",
            dataIndex: 'planNum'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/standardTeam/config/list",
          delete: "/standardTeam/config/delete",
          deleteBatch: "/standardTeam/config/deleteBatch",
          exportXlsUrl: "/standardTeam/config/exportXls",
          importExcelUrl: "standardTeam/config/importExcel",
        },
        dictOptions:{},
        chooseRowId:"",
        chooseRow:{},
        customRow:(record)=>{
          return {
            on:{
              click:(event)=>{
                this.chooseRow=record;
                this.chooseRowId=record.id;
              }
            }
          }
        }
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
        
      },
      rowClassName(record){
        if(record.id==this.chooseRowId){
          return "row-choose-bgblue";
        }
      },
      handleBaseSelectChange(value){
        this.loadData(1);
      },
      handleEdit: function (record) {
          this.$refs.modalForm.edit(record);
          this.$refs.modalForm.title = "编辑";
          this.$refs.modalForm.disableSubmit = false;
      },
      handleAdd: function () {
        console.log('queryParam',this.queryParam)
        console.log('baseId',this.queryParam.baseId)
        console.log('modalForm',this.$refs.modalForm)
        let baseId=this.queryParam.baseId?this.queryParam.baseId:''
        let record=this.queryParam
        this.$refs.modalForm.add(record);
        this.$refs.modalForm.title = "新增";
        this.$refs.modalForm.disableSubmit = false;
      },
    },
    watch:{
      chooseRowId(newVal){
        this.$emit("chooseDepart",this.chooseRow)
      }
    }
  }
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
  .div-query-banner{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    &>*:nth-child(n){
      width:200px
    }
    &>*:nth-child(n+2){
      margin-left: 12px;
    }
    &>.query-banner-btn:nth-child(n){
      width:100px
    }
  }
  /deep/.row-choose-bgblue{
    background: #e6f7ff !important;
  }
</style>